import { render, staticRenderFns } from "./CreateBonusModal.vue?vue&type=template&id=7b580bdb"
import script from "./CreateBonusModal.vue?vue&type=script&lang=js"
export * from "./CreateBonusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports